export enum JobApplyType {
  ONLINE = "ONLINE",
  EMAIL = "EMAIL",
  PHONE = "PHONE",
  POSTAL = "POSTAL"
}
